import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSquareCaretDown, faSquareCaretUp } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'orders-report-summary',
  imports: [FontAwesomeModule],
  templateUrl: './report-summary.component.html',
  styleUrl: './report-summary.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportSummaryComponent {
  public readonly summary = input.required<Summary>();

  protected isOpen = signal(false);
  protected closedIcon = faSquareCaretDown;
  protected openIcon = faSquareCaretUp;
}

interface Summary {
  inTransit: number;
  late: number;
  pickingUpToday: number;
}
